import { InfrastructureError } from '@goodt-wcore/errors';

/**
 * @typedef { import('./ApiClientError').TApiHttpClientErrorCode } TApiHttpClientErrorCode
 */

/**
 * Enum ошибок апи-сервиса
 *
 * @readonly
 * @enum string
 */
export const ApiHttpClientErrorCode = Object.freeze({
    INTERNAL: 0,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    UNAUTHORIZED: 401,
    INTERNAL_SERVER_ERROR: 500,
    BAD_REQUEST: 400,
    CONFLICT: 409
});

/**
 * Класс-исключение транспортного уровня для запросов к api
 * @class ApiHttpClientError
 */
class ApiHttpClientError extends InfrastructureError {
    /**
     */
    static Code = ApiHttpClientErrorCode;

    constructor(message, { code, data, reason } = {}) {
        super(message, { code, data, reason });
        this.name = 'ApiHttpClientError';
    }
}

export { ApiHttpClientError, ApiHttpClientError as default };
